export const getPublishStyleKr = (en) => {
  switch (en) {
    case 'popup_v':
      return '팝업 세로';
    case 'popup_h':
      return '팝업 가로';
    case 'banner_v':
      return '배너 세로';
    case 'banner_h':
      return '배너 가로';
    case 'drawer':
      return '서랍형';
    default:
      return '';
  }
};

export const getPublishStyleEn = (kr) => {
  switch (kr) {
    case '팝업 세로':
      return 'popup_v';
    case '팝업 가로':
      return 'popup_h';
    case '배너 세로':
      return 'banner_v';
    case '배너 가로':
      return 'banner_h';
    case '서랍형':
      return 'drawer';
    default:
      return '';
  }
};
